import { axiosInstance } from './index';
import { EmailRequestType, EnquiryRequestType } from '../../types/email';

export const emailService = {
    async create(data: EmailRequestType) {
        await axiosInstance.post('Enquiry', data);
    },
};

export const enquiryService = {
    async create(data: EnquiryRequestType) {
        await axiosInstance.post('Enquiry', data);
    },
};
